export const teamMembers2 = [
  {
    name: "Timo Lambing",
    role: "Founder & CEO",
    image: "/assets/img/timo.jpg",
    socials: [
      {
        name: "LinkedIn",
        url: "https://www.linkedin.com/in/timo-lambing-178a49153",
      },
      { name: "Github", url: "https://github.com/TimoLambing" },
    ],
  },
  {
    name: "Ann-Kristiin Reimann",
    role: "Chief of Marketing",
    image: "/assets/img/ann-kristiin.jpg",
    socials: [
      {
        name: "LinkedIn",
        url: "https://www.linkedin.com/in/ann-kristiin-reimann-349506216/",
      },
      { name: "Instagram", url: "https://www.instagram.com/ak47kristiin/" },
    ],
  },
];
